export interface Landscape {
  name: string;
  id: number
}

export const LANDSCAPES: Landscape[] = [
  { name: 'beach', id: 4 },
  { name: 'city', id: 2 },
  { name: 'cobblestones', id: 6 },
  { name: 'fields', id: 5 },
  { name: 'forest', id: 3 },
  { name: 'mountain', id: 1 },
];